"use client";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ScrollDownButton, ScrollUpButton } from "@radix-ui/react-select";
import React, { ReactElement, useMemo } from "react";
// import { Label } from "@/components/ui/label";
export interface StringToSelectionOptionEntry {
  leftElement?: ReactElement;
  group?: string | undefined;
  displayValue: string;
  identifier: string;
}
type props = {
  description?: string | undefined;
  options: StringToSelectionOptionEntry[];
  currentIdentifier: string;
  disableDropDownIfOneOption?: boolean;
  isInpreviewMode?: boolean;
  onSelectionChange: (selectedOptionIdentifier: string) => void;
};

export default function StringToSelect({
  description,
  options,
  currentIdentifier,
  disableDropDownIfOneOption,
  isInpreviewMode,
  onSelectionChange,
}: props) {
  function handleValueChangeLogic(selectedValue: string) {
    onSelectionChange(selectedValue);
  }
  function renderDescription() {
    if (description == null) return;
    return (
      <label
        className={`xs:text-xs md:text-md my-auto mr-2 text-[12px] font-bold text-secondary transition-all sm:text-sm lg:text-lg`}
        htmlFor={description}
      >
        {description}
      </label>
    );
  }

  function renderOptionEntry(option: StringToSelectionOptionEntry) {
    return (
      <div className="flex flex-row space-x-2">
        {option.leftElement}
        <span className="my-auto justify-center text-center">
          {option.displayValue}
        </span>
      </div>
    );
  }
  const categorizedOptions = useMemo(() => {
    let ret = new Map<string, StringToSelectionOptionEntry[]>();
    options.forEach((option) => {
      let targetKey = option.group ?? "";
      let newOptions: StringToSelectionOptionEntry[] = ret.get(targetKey) ?? [];
      newOptions.push(option);
      ret.set(targetKey, newOptions);
    });
    return ret;
  }, [options]);
  function renderOptions() {
    return (
      <>
        {Array.from(categorizedOptions).map(
          ([group, groupOptions], outerIndex) => (
            <SelectGroup key={outerIndex}>
              <SelectLabel className="bg-base-400 px-2 text-sm">
                {group}
              </SelectLabel>
              {groupOptions.map((groupOption, index) => (
                <SelectItem
                  className="focus:text-base-200"
                  key={index}
                  value={groupOption.identifier}
                >
                  {renderOptionEntry(groupOption)}
                </SelectItem>
              ))}
            </SelectGroup>
          )
        )}
      </>
    );
  }
  function renderSelect() {
    if (options.length == 1 && disableDropDownIfOneOption == true) {
      return renderOptionEntry(options[0]);
    }
    const currentOption = options.find(
      (x) => x.identifier == currentIdentifier
    );
    return (
      <Select
        disabled={isInpreviewMode == true}
        value={currentOption?.identifier}
        onValueChange={(newSelectedIdentifier) => {
          handleValueChangeLogic(newSelectedIdentifier);
        }}
      >
        <SelectTrigger className="h-full w-full border-0 bg-base-100 font-bold">
          <SelectValue placeholder={currentOption?.displayValue} />
        </SelectTrigger>
        <SelectContent className="max-h-[var(--radix-select-content-available-height)] border-0 bg-base-200 text-base-content">
          <ScrollUpButton />
          {renderOptions()}
          <ScrollDownButton />
        </SelectContent>
      </Select>
    );
  }
  return (
    <div className="m-0 flex h-full w-full ">
      {renderDescription()}
      {renderSelect()}
    </div>
  );
}
